import { api } from './api';

export const platformSaasSubscriptionsDashboardService = {
  getDashboardMetrics: () => api.get('/api/platform-admin/dashboard'),
  listTenants: () => api.get('/api/platform-admin/tenants'),
};
